import { useFormContext } from 'react-hook-form'
import EdSwitch from '@/components/forms/EdSwitch'

interface AttoreDidattico {
  user_id: string;
  email: string;
  first_name: string;
  last_name: string;
}

interface AttoriDidatticiSectionProps {
  isReadOnly?: boolean;
  data?: AttoreDidattico[];
}

const AttoriDidatticiSection = ({ isReadOnly = false, data = [] }: AttoriDidatticiSectionProps) => {
  const { register, watch, setValue } = useFormContext();

  const selections = watch('attoriSelezionati') || {};
  const tipoSelezione = watch('tipoSelezioneAttori') || 'enti';

  return (
    <div className="flex flex-col gap-4">
      <span className="text-[20px] text-[#4F4F4F] font-bold">Selezione Attori didattici</span>

      {/* Radio buttons per tipo selezione */}
      <div className="flex gap-6">
        <label className={`flex items-center gap-2 ${isReadOnly ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
          <input
            type="radio"
            value="enti"
            {...register('tipoSelezioneAttori')}
            disabled={isReadOnly}
            className={`w-4 h-4 text-[#B80F15] border-gray-300 focus:ring-[#B80F15] ${isReadOnly ? 'cursor-not-allowed ' : ''}`}
          />
          <span className="text-sm text-[#4F4F4F]">Enti</span>
        </label>
        <label className={`flex items-center gap-2 ${isReadOnly ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}>
          <input
            type="radio"
            value="soggetto_attuatore"
            {...register('tipoSelezioneAttori')}
            disabled={isReadOnly}
            className={`w-4 h-4 text-[#B80F15] border-gray-300 focus:ring-[#B80F15] ${isReadOnly ? 'cursor-not-allowed opacity-50' : ''}`}
          />
          <span className="text-sm text-[#4F4F4F]">Soggetto attuatore</span>
        </label>
      </div>

      {/* Lista attori con switch */}
      <div className="w-full">
        {data.length > 0 && data.map((item, idx) => {
            const checked = !!selections?.[item.user_id];
            const fullName = [item.first_name, item.last_name].filter(Boolean).join(' ') || item.email;
            return (
              <div key={item.user_id} className={`flex items-center justify-between px-0 py-1.5 ${idx !== data.length - 1 ? 'border-b border-gray-200' : ''}`}>
                <div className="flex items-center gap-12">
                  <div className="flex items-center gap-3 min-w-[180px]">
                    <span className="text-sm text-black">{fullName}</span>
                  </div>
                  <span className="text-sm text-[#6B7280]">{item.email}</span>
                </div>
                <div className="flex items-center gap-2">
                  <EdSwitch
                    id={`attore-${item.user_id}`}
                    value={checked}
                    onChange={() => setValue(`attoriSelezionati.${item.user_id}`, !checked, { shouldDirty: true })}
                    disabled={isReadOnly}
                  />
                  <span className={`text-sm ${checked ? 'text-black' : 'text-gray-400'}`}>Selezionato</span>
                </div>
              </div>
            );
        })}
      </div>
    </div>
  )
}

export default AttoriDidatticiSection
